module.exports = __webpack_public_path__ + "img/renwu_yao@2x.2becd2de.png";